import React, { useContext, useState, useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";
import NavigationContext from "../../context/navigation/NavigationContext";
import { GalleryConfig } from "./GalleryConfig";
import { env } from "../../env";

const Gallery = () => {
  const navigationContext = useContext(NavigationContext);
  const { autorunBanner } = navigationContext;

  const [index, setIndex] = useState(0);
  const [galleryObj, setGalleryObj] = useState();
  const [paused, setPaused] = useState(false);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const API_RESOURCES = env.REACT_APP_HMW_API_RESOURCES;
  let galleryConfig = async () => {
    try {
      let resp = await GalleryConfig();
      setGalleryObj(resp);
      console.log("RESP---->", galleryObj);
    } catch (err) {
      console.log("Error in getting gallery config");
    }
  };

  useEffect(() => {
    galleryConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const noOfSlides = galleryObj ? galleryObj.length : null;

  return (
    <div>
      <Carousel
        variant="dark"
        activeIndex={index}
        indicators={noOfSlides && noOfSlides > 1 ? true : false}
        onSelect={handleSelect}
        interval={autorunBanner && !paused ? 6000 : null}
        {...(noOfSlides &&
          noOfSlides > 1 && {
            "aria-roledescription": "carousel",
            role: "group",
          })}
        pause="hover"
        className={noOfSlides <= 1 && "gallery__banner"}
      >
        {galleryObj !== undefined &&
          galleryObj.map((ele, i) => (
            <Carousel.Item key={i}>
              <img
                className="d-block gallery__image"
                src={API_RESOURCES + ele.image}
                alt=""
                {...(noOfSlides &&
                  noOfSlides > 1 && {
                    role: "group",
                    "aria-roledescription": "slide",
                    "aria-label": `${i + 1} + " of " + noOfSlides`,
                  })}
              />
              <Carousel.Caption className="gallery__caption">
                <h1 className="gallery__caption__header">
                  {ele.galleryTitleText}
                </h1>
                <p
                  className="gallery__caption__info"
                  dangerouslySetInnerHTML={{ __html: ele.galleryText }}
                ></p>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
      </Carousel>
      {noOfSlides && noOfSlides > 1 && (
        <div className="gallery__control">
          <i
            className={
              !paused
                ? "fas fa-play gallery__control__button"
                : "fas fa-play gallery__control__button__active"
            }
            onClick={() => setPaused(false)}
            aria-label="Play slide show"
            role="button"
          ></i>
          <i
            className={
              paused
                ? "fas fa-pause gallery__control__button"
                : "fas fa-pause gallery__control__button__active"
            }
            onClick={() => setPaused(true)}
            aria-label="Stop automatic slide show"
            role="button"
          ></i>
        </div>
      )}
    </div>
  );
};

export default Gallery;
